import request from './request';

export function getTaskList() {
  return request.get('/api/task/taskList');
}
export function claimTaskReward(taskId) {
  return request.post('/api/task/claimReward', { task_id: taskId });
}
export function reportTaskProgress(taskKey, count = 1) {
  return request.post('/api/task/reportProgress', { task_key: taskKey, count });
}
export function dailySignin() {
  return request.post('/api/task/signin');
}
